import React, {Component} from 'react';

import './Iframe.scss';

export default class Iframe extends Component {

    render() {
        const {url, title, text} = this.props;

        const textHTML = text ? this.buildText(text) : null;

        const spacer = this.props.hideSpacer ? null : <div className="Iframe__vertical-spacer"/>;

        return (
            <div className="Iframe">
                {spacer}
                <iframe src={url} width="240" height="135" frameBorder="0" title={title} allowFullScreen></iframe>
                {textHTML}
            </div>
        )
    }

    buildText(text) {
        return (
            <div className="Iframe__inner">
                <p className="Iframe__text">
                    {text}
                </p>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/DetailPage/Iframe/index.js